$(function () {
    var $switch_btn = $('#menu-nav--mobile__switch-btn');

    if($switch_btn.length === 0 ){
        return;
    }

    $switch_btn.click(function(e){
        e.preventDefault();
        $switch_btn.toggleClass('menu-nav--mobile--showing');
        $('body').toggleClass('fixed');
    });

    $('#menu-nav--mobile__blank').click(function(e){
        e.preventDefault();
        $switch_btn.removeClass('menu-nav--mobile--showing');
        $('body').removeClass('fixed');
    });

});
